function Ratios(firstPillar, secondPillar, thirdPillar) {
  const total = firstPillar + secondPillar + thirdPillar
  this.calculate = function () {
    return {
      firstPillar: Math.round(firstPillar / total * 100) || 0,
      secondPillar: Math.round(secondPillar / total * 100) || 0,
      thirdPillar: Math.round(thirdPillar / total * 100) || 0
    }
  }
}